import React, { useState } from 'react';
import { FaDownload, FaBook } from 'react-icons/fa';
import useEditorStore from '../../store/editorStore';
import ExportModal from '../modals/ExportModal';
import logoImage from '../../assets/image/logo.png';
import './Header.css';

function Header({ onShowTutorial }) {
  const { canvas, zoom, setZoom, resetView } = useEditorStore();
  const [showExportModal, setShowExportModal] = useState(false);

  return (
    <>
      <header className="header">
        <div className="header-left">
          <div className="brand-logo">
            <img src={logoImage} alt="PEA E-Poster" className="pea-logo-img" />
          </div>
        </div>

        <div className="header-center">
          <div className="zoom-controls">
            <button 
              className="zoom-btn"
              onClick={() => setZoom(zoom - 0.1)}
              title="ย่อ"
            >
              −
            </button>
            <span className="zoom-value">{Math.round(zoom * 100)}%</span>
            <button 
              className="zoom-btn"
              onClick={() => setZoom(zoom + 0.1)}
              title="ขยาย"
            >
              +
            </button>
          </div>
        </div>

        <div className="header-right">
          <div className="action-group">
            <button 
              className="header-icon-btn" 
              onClick={onShowTutorial}
              title="ดูคู่มือการใช้งาน"
            >
              <FaBook />
            </button>
          </div>
          
          <div className="divider-vertical"></div>

          <button 
            className="btn-export-primary"
            onClick={() => setShowExportModal(true)}
          >
            <FaDownload /> Export
          </button>
        </div>
      </header>

      {showExportModal && (
        <ExportModal onClose={() => setShowExportModal(false)} />
      )}
    </>
  );
}

export default Header;
